// extracted by mini-css-extract-plugin
export default {"newTitle":"styles_newTitle__Jb+1v"};